import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import '@/App.css';
import Home from './pages/Home';
import Founder from './pages/Founder';
import Courses from './pages/Courses';
import LessonPlans from './pages/LessonPlans';
import GenZPrograms from './pages/GenZPrograms';
import Settings from './pages/Settings';
import Checkout from './pages/Checkout';
import ThankYou from './pages/ThankYou';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ChatBot from './components/ChatBot';
import WhatsAppButton from './components/WhatsAppButton';
import { Toaster } from '@/components/ui/sonner';

function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/founder" element={<Founder />} />
          <Route path="/courses" element={<Courses />} />
          <Route path="/lesson-plans" element={<LessonPlans />} />
          <Route path="/genz-programs" element={<GenZPrograms />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/thank-you/:orderId" element={<ThankYou />} />
        </Routes>
        <Footer />
        <ChatBot />
        <WhatsAppButton />
        <Toaster />
      </div>
    </BrowserRouter>
  );
}

export default App;